var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowFaqs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 4,
    viewBox: "0 0 4 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.81567 3.43015L0.951944 5.86584C0.550964 6.20688 -2.75873e-08 5.85833 -3.21881e-08 5.26362L-6.72114e-08 0.736377C-7.18122e-08 0.141665 0.550965 -0.206883 0.951945 0.134162L3.81568 2.56985C4.06144 2.77888 4.06144 3.22112 3.81567 3.43015Z",
    fill: "#041E5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowFaqs);
export default __webpack_public_path__ + "static/media/left-arrow-faqs.5ecf92c07cdb29f9fa54e616275c2173.svg";
export { ForwardRef as ReactComponent };